<template>
    <div class="energyDataType-box">
        <div class="energyDataType-left">
            <el-container>
                <el-main ref="elMain" style="height: calc(100vh - 10rem);">
                    <el-tree
                            class="filter-tree"
                            :data="tree"
                            :props="defaultProps"
                            node-key="id"
                            default-expand-all
                            @node-click="treeClick"
                            v-loading="loading"
                            :expand-on-click-node="false"

                    >
                    </el-tree>
                    <center>
                        <el-button v-if="(tree ===null || tree.length === 0) && !loading" @click="">刷新
                        </el-button>
                    </center>
                </el-main>
            </el-container>
        </div>
        <div class="div-hr-h"></div>
        <div class="energyDataType-right">
            <el-button size="small" icon="el-icon-plus" type="primary" @click="open" style="border-radius: 20px"
                       v-loading="buttonLoading">添加子节点
            </el-button>
            <el-button size="mini" icon="el-icon-delete" type="text" @click="deleteCustomerEnergy"
                       style="color: #F56C6C;margin-left: 1rem">删除
            </el-button>
            <el-row>
                <el-col :span="8" style="margin-top: 1rem;
                font-weight: 600;">能源分类分项
                </el-col>
            </el-row>
            <el-form :model="formData" size="small" :rules="myRules" ref="energyUnitForm" style="margin-top: 1rem;"
                     :label-position="labelPosition">

                <el-row>
                    <el-col :span="8">
                        <!--在口径设置中出现-->
                        <el-form-item label="名称" :label-width="formLabelWidth">
                            <el-input v-model="formData.name" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <!--在能耗单元设置中出现-->
                    <el-col :span="8">
                        <el-form-item label="代码" :label-width="formLabelWidth">
                            <el-input v-model="formData.code" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <!--在能耗单元设置中出现-->
                        <el-form-item label="级别"
                                      prop="name" :label-width="formLabelWidth">
                            <el-input v-model="formData.grade"
                                      @blur="formData.grade = formData.grade.replace(/\s/g,'')" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <!--在能耗单元设置中出现-->
                        <el-form-item label="排列序号"
                                      prop="name"
                                      :label-width="formLabelWidth">
                            <el-input v-model="formData.order"
                                      @blur="formData.order = formData.order.replace(/\s/g,'')" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <!--在能耗单元设置中出现-->
                        <el-form-item label="功率单位"
                                      prop="name"
                                      :label-width="formLabelWidth">
                            <el-input v-model="formData.powerUnit"
                                      @blur="formData.powerUnit = formData.powerUnit.replace(/\s/g,'')"
                                      disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <!--在能耗单元设置中出现-->
                        <el-form-item label="单位"
                                      prop="name"
                                      :label-width="formLabelWidth">
                            <el-input v-model="formData.note"
                                      @blur="formData.note = formData.note.replace(/\s/g,'')" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <!--在能耗单元设置中出现-->
                        <el-form-item label="标准煤"
                                      prop="name"
                                      :label-width="formLabelWidth">
                            <el-input v-model="formData.standardCoal"
                                      @blur="formData.standardCoal = formData.standardCoal.replace(/\s/g,'')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <!--在能耗单元设置中出现-->
                        <el-form-item label="碳排放"
                                      prop="name"
                                      :label-width="formLabelWidth">
                            <el-input v-model="formData.carbon"
                                      @blur="formData.carbon = formData.carbon.replace(/\s/g,'')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :span="8">
                    <el-form-item style="margin-left: 12rem">

                        <el-button type="primary" @click="updateCustomerEnergy"
                        >
                            保 存
                        </el-button>

                    </el-form-item>
                </el-row>

            </el-form>
        </div>
        <el-dialog title="能源分项列表" :visible.sync="visible" width="25%">
            <el-container>
                <el-main ref="elMain" style="height: calc(45vh + 4rem);">
                    <el-tree
                            show-checkbox
                            :data="energyItemTree"
                            :props="energyItemProps"
                            node-key="guidenergyid"
                            default-expand-all
                            ref="tree"
                            highlight-current
                            @node-contextmenu="rightClick"
                            :expand-on-click-node="false"
                            :default-checked-keys="customerKeys"



                    >
                    </el-tree>
                    <center>
                        <el-button v-if="(tree ===null || tree.length === 0) && !loading" @click="">刷新
                        </el-button>
                    </center>
                </el-main>
            </el-container>
            <span slot="footer" class="dialog-footer" style="height: 4rem">
        <el-button @click="visible = false" size="small">取消</el-button>
        <el-button type="primary" @click="save" size="small">保存</el-button>
      </span>

        </el-dialog>
    </div>

</template>

<script>
  import {tree, deleteCustomerEnergy, updateCustomerEnergy} from '@/api/customerEnergy'
  import {energyItemTree, saveCustomerDataType} from '@/api/EnergyItem'
  import {mapGetters} from 'vuex'
  import {Message, MessageBox} from 'element-ui'

  export default {
    name: 'collectionManage',
    computed: {
      ...mapGetters([
        'customerId'
      ])
    },
    data() {
      return {
        labelPosition: 'left',
        formLabelWidth: '7rem',
        customerKeys: [],
        formLoading: false,
        visible: false,
        loading: false,
        buttonLoading: false,
        tree: [],
        energyItemTree: [],
        formData: {},
        defaultProps: {
          children: 'children',
          label: 'name'
        }, energyItemProps: {
          children: 'children',
          label: 'strname'
        }, myRules: {
          /* 正则*/
          approachName: [
            {required: true, message: '仪表名称不能为空', trigger: 'change'}
          ],
          aName: [
            {required: true, message: '请填写能耗单元名称', trigger: 'change'}
          ],
          enabled: [
            {required: true, message: '请选择是否启用', trigger: 'change'}
          ],
          order: [
            {required: true, message: '请填写排列顺序', trigger: 'change'}/*,
            {validator: checkNum, trigger: 'change'}*/
          ],
          id: [
            {required: true, message: '请填写编号标号', trigger: 'change'}
          ],
          type: [
            {required: true, message: '请选择区域类型', trigger: 'change'}
          ],
          name: [
            {required: true, message: '请填写口径名称', trigger: 'change'},
            {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'change'}
          ],
          meterId: [
            {required: true, message: '请选择要添加的仪表', trigger: 'change'}
          ],
          typeId: [
            {required: true, message: '请选择要添加的业主用户', trigger: 'change'}
          ],
          customerIds: [{required: true, message: '请选择要添加的用户', trigger: 'blur'}],
          code: [{required: true, message: '请填写代码', trigger: 'blur'}, {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符',
            trigger: 'change'
          }],
          note: [{min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'change'}]
        }
      }
    },
    mounted() { /* 页面初始化完成加载数据*/
      this.start()
    },
    methods: {
      updateCustomerEnergy() {
        this.formLoading = true
          debugger
        updateCustomerEnergy(this.formData).then(response => {
          if (response.code === 200 && response.infoJson === true) {
            this.$message({
              type: 'success',
              message: '修改能源分项信息成功',
              duration: 5 * 1000
            })

            this.start()
          }
          else
            this.$message({
              type: 'error',
              message: '修改能源分项信息失败',
              duration: 5 * 1000
            })
          this.formLoading = false
        }).catch(error => {
          console.log(error)
          this.$message({
            type: 'error',
            message: '修改能源分项信息失败',
            duration: 5 * 1000
          })
          this.formLoading = false
        })
      },
      deleteCustomerEnergy() {
        if (this.formData === undefined || this.formData === null || this.formData.id === undefined) {
          this.$message({
            type: 'warning',
            message: '请选择要删除的能源分项',
            duration: 5 * 1000
          })
          return
        }
        this.$confirm('此操作将永久删除该能源分项以及其子分项, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteCustomerEnergy(this.formData.id, this.formData.customerId).then(response => {
            if (response.code === 200 && response.infoJson === true) {
              this.$message({
                type: 'success',
                message: '删除成功',
                duration: 5 * 1000
              })
              this.start()
            }
            else {
              this.$message({
                type: 'error',
                message: '删除失败',
                duration: 5 * 1000
              })
            }
          }).catch(error => {
            console.log(error);
            this.$message({
              type: 'error',
              message: '删除失败',
              duration: 5 * 1000
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      start() {
        this.buildTree(this.customerId).then(response => {
          console.log(response)
          this.tree = []
          if (response != null && response.infoJson != null && response.infoJson.length !== 0) {
            this.tree.push({name: '能源分类', children: response.infoJson, grade: -1})
            this.formData = this.tree[0].children[0]
          }
          else {
            this.tree.push({name: '能源分类', children: null, grade: -1})
            this.formData = {}
          }
          this.loading = false

        })
      },
      save() {
          debugger
        const keys = this.$refs.tree.getHalfCheckedKeys().concat(this.$refs.tree.getCheckedKeys())
        saveCustomerDataType(this.customerId, keys).then(response => {
          if (response.code === 200 && response.infoJson === true) {
            this.$message({
              type: 'success',
              message: '添加成功',
              duration: 5 * 1000
            })
          }
          else {
            this.$message({
              type: 'error',
              message: '添加失败',
              duration: 5 * 1000
            })
          }
          this.visible = false
          this.start()
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '添加失败',
            duration: 5 * 1000
          })
          console.log(error)
          this.visible = false
        })
      },
      energyItemTreeFun() {
        return new Promise((resolve, reject) => {
          energyItemTree().then(response => {
            if (response.code === 200) {
              this.energyItemTree = response.infoJson
              this.visible = !this.visible

            }
            else {
              this.$message({
                type: 'error',
                message: '查询分项树失败',
                duration: 5 * 1000
              })
            }
            this.buttonLoading = false
            resolve(null)
          }).catch(error => {
            this.buttonLoading = false
            this.$message({
              type: 'error',
              message: '查询分项树失败',
              duration: 5 * 1000
            })
            reject(error)
          })
        })
      },
      open() {
        this.energyItemTreeFun().then(() => {
            this.getAllKeys()
            console.log(this.$refs.tree)
          }
        )

      },
      getAllKeys() {/*获取当前客户所有树的id*/
        let data = this.tree[0].children
        if (data === null || data.length === 0) return
        this.$refs.tree.setCheckedKeys([])
        this.getKeys(data)
        console.log(this.tree)
        console.log(this.customerKeys)
      }, getKeys(data) {
        for (let i in data) {
          /*if (data[i].parentId !== 'host')*/
          /*this.customerKeys.push(data[i].id)*/
          this.$refs.tree.setChecked(data[i].id, true)
          if (data[i].children !== undefined && data[i].children !== null && data[i].children.length !== 0)
            this.getKeys(data[i].children)
        }
      },
      treeClick(row) {
        if (row.grade != -1) this.formData = row
        console.log(this.formData)
      },
      rightClick(row,node){/*右击事件*/
     /*   console.log(node)
        let data = Object.assign([],this.$refs.tree.getCheckedKeys())
        for (let i in data)
        {
          console.log(data[i])
        }*/
        this.$refs.tree.setChecked(node.guidenergyid, true)

      },
      buildTree(customerId) {
        return new Promise((resolve, reject) => {
          this.loading = true
          tree(customerId).then(response => {
            if (response.code === 200)
              resolve(response)
            else {
              reject(response.message)
            }

            this.loading = false
          }).catch(error => {
            this.loading = false
            reject(error)
          })
        })
      }, tableStringFormat(row, column, cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          return cellValue
        }
        return '--'
      }, alarmReceivingModeFormat(row, column, cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          if (cellValue + '' === '0') return '不接收'
          else if (cellValue + '' === '1') return '短信'
          else if (cellValue + '' === '2') return '邮件'
          else if (cellValue + '' === '3') return '短信+邮件'
        }
        return '--'
      }, enabledFormat(row, column, cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          if (cellValue + '' === '0') return '不启用'
          else if (cellValue + '' === '1') return '启用'
        }
        return '--'
      }
    }

  }
</script>
<style scoped rel="stylesheet/scss" lang="scss">
    .energyDataType-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        box-sizing: border-box;

        .energyDataType-left {
            display: flex;
            width: 13vw;
            .el-tree {
                min-width: 100%;
                display:inline-block !important;
                background: #f6f7f7 !important;
            }
        }
        .div-hr-h {
            height: 100%;
            width: 0.02rem;
            background-color: #dedede;
        }
        .energyDataType-right {
            padding-top: 1rem;
            padding-left: 2rem; /*==等于左边栏宽度==*/
            /*background-color: gray;*/
            height: calc(100vh - 10rem);
            /*width: calc(80% - 2rem);*/
            width: calc(100% - 13vw - 2.02rem);
        }

    }
</style>
<!--
<style>
    .energyDataType-box .el-dialog__body {
        border-top: 1px solid #dedede;
        border-bottom: 1px solid #dedede;
    }

</style>-->
